export default {
      id: "hex_info-usage",
      viewBox: "0 0 300.6 327",
      url: __webpack_public_path__ + "sprite.svg#hex_info",
      toString: function () {
        return this.url;
      }
    }